import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { POLICY_STATUS_CHOICES, STATUS_CLASSNAMES } from 'app-constants'

// import { connect } from "react-redux";

class UserClaimCard extends Component {
  render() {
    let claim = this.props.claim
    let product = claim.policy.product
    let logoUrl = product.company.logoUrl
    return (
      <div className="user-dash-card mr-2rem mb-2rem">
        <div>
          <div className="space-between">
            <span className="user-dash-card__category">{product.name}</span>
            <span
              className={`user-dash-card__status user-dash-card__status${
                STATUS_CLASSNAMES[product.status]
              }`}
            >
              {POLICY_STATUS_CHOICES[product.status]}
            </span>
          </div>

          {/* <div className="user-dash-card__description">
            Claim value: <span className="text--muted">10000</span>
          </div>
          <div className="user-dash-card__description">
            Reason for claim: <span className="text--muted">Reason text</span>
          </div> */}
        </div>

        <div>
          <img
            className="user-dash-card__logo"
            src={logoUrl}
            alt="Insurer Logo"
          />
        </div>
      </div>
    )
  }
}
UserClaimCard.propTypes = {
  claim: PropTypes.shape({
    policy: PropTypes.shape({
      product: PropTypes.shape({
        status: PropTypes.string,
        name: PropTypes.string,
        company: PropTypes.shape({
          logoUrl: PropTypes.string
        })
      })
    })
  })
}

export default UserClaimCard
